import { render, staticRenderFns } from "./CopyReportDialog.vue?vue&type=template&id=fa3fcf48"
import script from "./CopyReportDialog.vue?vue&type=script&lang=js"
export * from "./CopyReportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports